module.exports = __webpack_public_path__ + "static/media/badge_challenge_3.60036ca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_challenge_3.png
// module id = 510
// module chunks = 0